import { get } from 'lodash-es'
import { MESSAGES_RESPONSE } from './constants'
import { SETS, stateSets } from './state'
import { REQUEST_STATE } from '@/js/plugins/store/modules/aimeos/constants'

export const TYPES = {
  MESSAGING_INFO_PENDING: 'MESSAGING_INFO_PENDING',
  MESSAGING_INFO_UNREAD_MESSAGES: 'MESSAGING_INFO_UNREAD_MESSAGES',
  MESSAGING_INFO_TOTAL_MESSAGES: 'MESSAGING_INFO_TOTAL_MESSAGES',
  MESSAGING_PENDING: 'MESSAGING_PENDING',
  MESSAGING_UNREAD_MESSAGES: 'MESSAGING_UNREAD_MESSAGES',
  MESSAGING_TOTAL_MESSAGES: 'MESSAGING_TOTAL_MESSAGES',
  MESSAGING_ITEMS: 'MESSAGING_ITEMS',
  NEWEST_RESPONSE_SET: 'NEWEST_RESPONSE_SET',
  TOTAL_MESSAGES: 'TOTAL_MESSAGES',
}

export default {
  [TYPES.MESSAGING_INFO_PENDING]: state =>
    state[stateSets[SETS.MESSAGES_INFO].stateKey] === REQUEST_STATE.STATE_PENDING,
  [TYPES.MESSAGING_INFO_TOTAL_MESSAGES]: state =>
    get(state, [stateSets[SETS.MESSAGES_INFO].dataKey, MESSAGES_RESPONSE.TOTAL], 0),
  [TYPES.MESSAGING_INFO_UNREAD_MESSAGES]: state =>
    get(state, [stateSets[SETS.MESSAGES_INFO].dataKey, MESSAGES_RESPONSE.UNREAD], 0),
  ['test']: state => state,
  [TYPES.MESSAGING_PENDING]:
    state =>
    (set = SETS.MESSAGES) =>
      state[stateSets[set].stateKey] === REQUEST_STATE.STATE_PENDING,
  [TYPES.MESSAGING_TOTAL_MESSAGES]:
    state =>
    (set = SETS.MESSAGES) =>
      get(state, [stateSets[set].dataKey, MESSAGES_RESPONSE.TOTAL], 0),
  [TYPES.MESSAGING_ITEMS]:
    state =>
    (set = SETS.MESSAGES) => {
      return get(state, [stateSets[set].dataKey, MESSAGES_RESPONSE.DATA], [])
    },
  // [TYPES.NEWEST_RESPONSE_SET]: state => {
  //   const messagesLastRequestDate = get(state, stateSets[SETS.MESSAGES].modifiedKey)
  //   const statusLastRequestDate = get(state, stateSets[SETS.MESSAGES_INFO].modifiedKey)
  //   return statusLastRequestDate && messagesLastRequestDate
  //     ? statusLastRequestDate > messagesLastRequestDate
  //       ? SETS.MESSAGES_INFO
  //       : SETS.MESSAGES
  //     : statusLastRequestDate
  //     ? SETS.MESSAGES_INFO
  //     : SETS.MESSAGES
  // },
  // [TYPES.TOTAL_MESSAGES]: (state, getters) => {
  //   return get(
  //     state,
  //     [stateSets[getters[TYPES.NEWEST_RESPONSE_SET]].dataKey, MESSAGES_RESPONSE.TOTAL],
  //     0,
  //   )
  // },
}
